import { recordMark } from '@stitch-fix/client-analytics-reporter';
import Cookies from 'js-cookie';
import { sendLog } from '../../utils/sendMetrics';
import { useGetCreditIncentivesEligibilityQuery } from './getCreditIncentivesEligibility';
import mockedResponse from './useGetCreditIncentivesEligibilityQuery.mockedResponse';

const useCreditIncentivesEligibilityQuery = ({
  clientHasPurchases,
  error,
  loading,
  skip,
}) => {
  const variables = {
    // Required to use prod data in development since the visitor uuid cookie can't be sent cross site.
    visitorId:
      window.gon.env === 'development' ? Cookies.get('visitor_uuid') : null,
    configParamsInput: {
      offlineLookupOnly: false,
      params: [
        {
          name: 'eng.kufak.freestyle.credit_incentive.test_case_1',
          fallbackValue: 'Hidden',
          expectedValues: ['Hidden', 'Accessible'],
        },
      ],
    },
  };

  const {
    data: creditIncentivesEligibilityData,
    loading: creditIncentivesEligibilityLoading,
    error: creditIncentivesEligibilityError,
  } = useGetCreditIncentivesEligibilityQuery({
    /**
     * NOTE: Checking for allocation also allocates clients.  We want to only allocate eligible clients
     * and clients with existing purchases are ineligible.
     *
     * Specifically checking the client does not have purchases is done because it is initially set as `null`
     * since we cannot verify whether they have previous purchases or not
     */
    skip: clientHasPurchases !== false || error || loading || skip,
    variables,
    onCompleted: () => {
      recordMark('get_credit_incentives_eligibility_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('get_credit_incentives_eligibility_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(
        `GetCreditIncentivesEligibility error: ${creditIncentivesEligibilityError}`,
        {
          errorMessage: creditIncentivesEligibilityError,
        },
      );
    },
  });

  if (window.gon.use_mock_graphql_data) {
    return {
      creditIncentivesEligibilityData: mockedResponse.data,
      creditIncentivesEligibilityLoading,
      creditIncentivesEligibilityError,
    };
  }

  return {
    creditIncentivesEligibilityData,
    creditIncentivesEligibilityLoading,
    creditIncentivesEligibilityError,
  };
};

export default useCreditIncentivesEligibilityQuery;
